import { DownloadLimitNotificationProps } from "../../types/components/downloads/DownloadLimitNotificationTypes"
import { DOWNLOAD_STATUS_ACTIONS } from "../../constants/actions";
import { ApplicationState } from "../../types/state/storeTypes";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { ExitIcon } from "../../modules/Icons";

const DownloadLimitNotification: React.FC<DownloadLimitNotificationProps> = (props) => {
  const { downloadStatus, dispatch } = props;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (downloadStatus.showDownloadLimitNotification) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          dispatch({
            type: DOWNLOAD_STATUS_ACTIONS.DOWNLOAD_STATUS_UPDATE,
            data: { showDownloadLimitNotification: false }
          });
        }, 300);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [downloadStatus.showDownloadLimitNotification, dispatch]);

  if (!downloadStatus.showDownloadLimitNotification || downloadStatus.downloads == 0 || downloadStatus.showUpgradeModal) {
    return <></>;
  }

  const getStatusColor = (downloads: number, limit: number) => {
    const lowThreshold = Math.floor(limit * 0.4);
    const mediumThreshold = Math.floor(limit * 0.6);

    if (downloads <= lowThreshold) {
      return { bg: 'bg-[#24C1FF]', text: 'text-[#24C1FF]' };
    } else if (downloads <= mediumThreshold) {
      return { bg: 'bg-[#FFAC26]', text: 'text-[#FFAC26]' };
    } else {
      return { bg: 'bg-[#CB333B]', text: 'text-[#CB333B]' };
    }
  };

  const { bg: statusBgColor, text: statusTextColor } = getStatusColor(downloadStatus.downloads, downloadStatus.downloadLimit);

  const handleUpgradeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    window.location.href = '/pricing';
  };

  const isPaidUser = downloadStatus.downloadLimit > 10;

  const paidUserText = 'Free and Essentials Assets Download'
  const freeUserText = 'Free Assets Download'

  const notificationText = isPaidUser ? paidUserText : freeUserText;

  return (
    <div className="fixed bottom-0 right-0 m-5 lg:w-[500px] z-40">
      <div className="w-full flex flex-col justify-between md:flex-row md:items-center gap-4 md:gap-12 bg-[#0B1113] py-4 px-6 rounded-[6px] mb-6">
        <div className="w-full">
          <div className='font-bold text-xs capitalize lg:text-[16px] mb-3'>{notificationText}</div>
          <div className='mb-5 text-xs lg:text-[14px] text-[#AEB6BA]'><span className={statusTextColor}>{downloadStatus?.downloads || 1}/</span>{downloadStatus.downloadLimit} daily downloads used</div>
          <div className={`w-full ${statusBgColor} bg-opacity-[30%] rounded-full h-[7px] md:mb-4`}>
            <div className={`${statusBgColor} h-[8px] rounded-full`} style={{width: `${((downloadStatus.downloads || 1) / downloadStatus.downloadLimit) * 100}%`}}></div>
          </div>
        </div>
        {!isPaidUser &&
          <button
            className='flex-col text-[16px] md:items-center md:justify-center bg-a-green rounded-[5px] lg:h-[40px] px-4 py-2 md:pr-4 text-white font-normal cursor-pointer'
            onClick={handleUpgradeClick}>
            Upgrade
          </button>
        }
        <ExitIcon className='cursor-pointer' onClick={() => dispatch({ type: DOWNLOAD_STATUS_ACTIONS.DOWNLOAD_STATUS_UPDATE, data: { showDownloadLimitNotification: false } })} />
      </div>
    </div>
  );
};

const mapDispatchToProps = (state: ApplicationState) => ({
  downloadStatus: state.downloadStatus,
});

export default connect(mapDispatchToProps)(DownloadLimitNotification);
